<template>
  <a-button
    @click="selectRequest()"
    :type="selectedRequestId === request.id ? 'primary' : 'default'"
  >
    <a-flex justify="space-between" align="center" gap="middle">
      <a-typography-text :content="request.title" ellipsis />

      <a-flex align="center" justify="end" gap="small">
        <a-badge v-if="!!unreadMessagesCount" :count="unreadMessagesCount" />
        <component :is="request.icon" style="font-size: 17px" />
      </a-flex>
    </a-flex>
  </a-button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import router from "@/router";
import type { SupportUserRequestDTO } from "@/api/api.dto";
import { useChatStore } from "@/stores/chat/chat.store";

const props = defineProps<{ request: SupportUserRequestDTO }>();
const chatStore = useChatStore();

const selectedRequestId = computed(() => chatStore.currentChatId);

const unreadMessagesCount = computed(
  () => chatStore.unreadMessagesCount[props.request.id],
);

const selectRequest = () => {
  router.push({
    name: "supportUserRequestSingle",
    params: { supportRequestId: props.request.id },
  });
};
</script>

<style scoped lang="scss"></style>
